import React from 'react';
import { usePlatformConfig } from 'hooks/PlatformContext';
import './index.scss';

const LoadingComponent: React.FC = () => {
  const platformConfig = usePlatformConfig();
  const name = platformConfig?.name || 'FUKKONI';
  const logo = platformConfig?.icon;

  return (
    <div className="loading-viewport">
      <div className="loading-card">
        {logo ? (
          <img src={logo} className="loading-logo-img" alt={name} />
        ) : (
          <div className="loading-brand-text">
            {name}<span>.</span>
          </div>
        )}
        <div className="modern-spinner-ring" />
      </div>
    </div>
  );
};

export default LoadingComponent;
